// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__Y7VP1","dragIcon":"SortableItem_dragIcon__1zgzl","disabled":"SortableItem_disabled__36XaV"};